export default function Footer() {
    return (
        <footer class="footer">
            <div class="mod-foot">
                <div class="inner">
                    <div class="bd">
                        <div class="navigation">
                            <p>
                                <a href="https://api.cn/article/" target="_blank">网站公告</a>
                                <a href="https://api.cn/article/2/" target="_blank">使用帮助</a>
                                <a href="https://api.cn/member/agreement/" target="_blank" rel="nofollow">用户协议</a>
                                <a href="https://api.cn/member/agreement/protocol/" target="_blank" rel="nofollow">服务协议</a>
                                <a href="https://api.cn/about/" target="_blank">关于我们</a>
                                <a href="https://api.cn/contact/" target="_blank">联系我们</a>
                                <a href="https://provider.local.api.cn/" target="_blank">商户入驻</a>
                                <a href="https://tui.api.cn/" target="_blank">成为推广员</a>
                            </p>
                        </div>
                        <div class="copy">
                            <p>
                                <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">闽ICP备2021016936号-1</a>
                                <span>|</span>
                                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302035353" target="_blank" rel="nofollow">闽公网安备 35020302035353号</a>
                                <span>|</span>
                                <a href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%E5%8E%A6%E9%97%A8%E5%B8%82%E5%B8%B8%E9%87%8F%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8" target="_blank" rel="nofollow">增值电信业务许可证 闽B2-20230476</a>
                            </p>
                            <p>
                                <a href="/">APi云市场</a>
                                <span>Copyright &copy {new Date().getFullYear()}</span>
                                <span>厦门市常量科技有限公司</span>
                                <span>版权所有</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}